
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import {
  CodeBlock,
  ComponentDocs,
  DocsTable,
  Preview,
  md,
} from "@lighting-beetle/lighter-styleguide";
import Dropdown, { DropdownItem } from "./index";
import { Button } from "../";

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1>{`Dropdown`}</h1>
    <p>{`A button triggered menu with a list of actions.`}</p>
    <h2>{`Example`}</h2>
    <Dropdown buttonProps={{
      children: "Dropdown"
    }} mdxType="Dropdown">
  <DropdownItem mdxType="DropdownItem">Action 1</DropdownItem>
  <DropdownItem mdxType="DropdownItem">Action 2</DropdownItem>
    </Dropdown>
    <h2>{`Variants`}</h2>
    <h3>{`Basic`}</h3>
    <Preview mdxType="Preview">
  <Dropdown buttonProps={{
        children: "Dropdown"
      }} mdxType="Dropdown">
    <DropdownItem mdxType="DropdownItem">Action 1</DropdownItem>
    <DropdownItem mdxType="DropdownItem">Action 2</DropdownItem>
  </Dropdown>
    </Preview>
    <h3>{`Interactive`}</h3>
    <p>{`Dropdown menu will not close after interaction inside of dropdown menu.`}</p>
    <Preview mdxType="Preview">
  <Dropdown buttonProps={{
        children: "Dropdown"
      }} interactive mdxType="Dropdown">
    <Button mdxType="Button">Action</Button>
  </Dropdown>
    </Preview>
    <h2>{`Props`}</h2>
    <ComponentDocs title="<Dropdown />" component={Dropdown} mdxType="ComponentDocs" />
    <ComponentDocs title="<DropdownItem />" component={DropdownItem} mdxType="ComponentDocs" />
    <h2>{`JS module reference`}</h2>
    <h3>{`Initializiation`}</h3>
    <p>{`All elements with `}<inlineCode parentName="p">{`data-dropdown`}</inlineCode>{` attribute will be initialised automatically.`}</p>
    <h3>{`Custom initialization`}</h3>
    <CodeBlock mdxType="CodeBlock">
  {`
    <div id="my-dropdown" role="menu" class="dropdown">
    ...
    </div>
  `}
    </CodeBlock>
    <CodeBlock language="jsx" mdxType="CodeBlock">
  {`
    window.addEventListener('DOMContentLoaded', () => {
    const myDropdown = window.myApp.Dropdown(document.getElementById('my-dropdown'));
    });
  `}
    </CodeBlock>
    <h3>{`Default config`}</h3>
    <CodeBlock language="jsx" mdxType="CodeBlock">
  {`
const defaultConfig = {
/** {element} Anchor of the dropdown menu. If none specified, the module queries for \`[aria-controls=dropdown-menu-id]\`. */
anchorElement: null,
/** {element} On init, all dropdowns are transported here, so that they can be used in overflowing containers. */
dropdownRoot: document.getElementById('root-dropdowns'),
/** {element} Root element of the app. Helps handling clicks outsite the dropdown */
appRoot: document.getElementById('root'),
/** {object} Popper.js options */
popperOptions: {
  placement: 'bottom-start',
  removeOnDestroy: true,
},
/** {func} On dropdown open callback function. */
onOpen: () => {},
/** {func} On dropdown close callback function. */
onClose: () => {},
};`}
    </CodeBlock>
    <h3>{`Methods`}</h3>
    <DocsTable data={[{
      prop: "update",
      type: "func",
      default: "() => {}",
      description: "Reint plugin. Calling `destroy()` and then `init()`"
    }, {
      prop: "destroy",
      type: "func",
      default: "() => {}",
      description: "Destroy plugin, deattach event listeners."
    }, {
      prop: "open",
      type: "func",
      default: "() => {}",
      description: "Opens dropdown if not already open."
    }, {
      prop: "close",
      type: "func",
      default: "() => {}",
      description: "Closes dropdown if not already closed."
    }, {
      prop: "static getInstance",
      type: "func",
      default: "element => {}",
      description: "Get instance of `Dropdown` attached to specific DOM element (usually `[data-dropdown]`)."
    }]} mdxType="DocsTable" />
    <h2>{`Accessiblity`}</h2>
    <p>{`Dropdowns are built according to `}<a parentName="p" {...{
        "href": "https://www.w3.org/TR/wai-aria-practices/#menu"
      }}>{`WAI-ARIA Authoring Practices 1.1`}</a>{`.
Current implementation does not support:`}</p>
    <ul>
      <li parentName="ul">{`navigation with left/right arrows`}</li>
      <li parentName="ul">{`opening menu with up/down arrows`}</li>
      <li parentName="ul">{`menuitemradio and menuitemcheckbox`}</li>
      <li parentName="ul">{`submenus`}</li>
    </ul>
    <p>{`Current implementation only supports keyboard navigation for dropdown MENUS, not dropdown dialogs/popovers. This makes interactive dropdowns behave unexpectedly - the user has to use arrow keys (up and down) to focus elements instead of the tab key. :(`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;